import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Table, TableWrap, Td, Th } from '@/components/ui/table';
import { api, type OAuthGrant } from '@/lib/api';

function formatDate(seconds: number | null): string {
  return seconds === null ? '—' : new Date(seconds * 1000).toLocaleDateString('ja-JP');
}

/**
 * OAuth で接続したクライアントの一覧と解除。
 *
 * **自分の接続しか返らない。** 管理者でも他人の接続は切れない (セッションの
 * 個別失効と同じ扱い。他人を止めるのはユーザーの無効化の役目)。
 *
 * 解除するとアクセストークンもリフレッシュトークンも同時に死ぬので、
 * そのクライアントは次の 1 回から通らなくなる。
 */
export function GrantList({ grants, onRevoked }: { grants: OAuthGrant[]; onRevoked: () => void }) {
  const [busy, setBusy] = useState(false);

  async function revoke(id: string) {
    setBusy(true);
    try {
      await api.delete(`/api/oauth/grants/${id}`);
      onRevoked();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="border border-line bg-surface-raised">
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <Th>CLIENT</Th>
              <Th>CONNECTED</Th>
              <Th>LAST USED</Th>
              <Th />
            </tr>
          </thead>
          <tbody>
            {grants.map((grant) => (
              <tr key={grant.id}>
                <Td>{grant.clientName}</Td>
                <Td className="font-mono text-xs">{formatDate(grant.createdAt)}</Td>
                <Td className="font-mono text-xs">{formatDate(grant.lastUsedAt)}</Td>
                <Td className="text-right">
                  <Button onClick={() => revoke(grant.id)} disabled={busy}>
                    {'解除'}
                  </Button>
                </Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableWrap>
    </div>
  );
}
